import * as React from "react"
import * as s from "./style.scss"
import { Select, Option } from "informed"

interface IProps {
    radiusItems: { value: number, description: string }[]
    initialRadius: number
    label: string
}

// Dynamic select element for the radius
export default ({ radiusItems, initialRadius, label }: IProps) => (
    <div className={s.dropdown}>
        <label className={s.header}>
            <span>{label}: </span>
            <span className={s.arrow}>
                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" />
                    <path d="M0-.75h24v24H0z" fill="none" />
                </svg>
            </span>
        </label>
        <Select field="radius" initialValue={initialRadius} className={s.selectElement}>
            {radiusItems.map((value) => (
                <Option key={`rad_sel_${value.value}`} value={value.value}>{value.description}</Option>
            )
            )}
        </Select>
    </div>
)